/**
 * Both mapping tables list Plan of Care items grouped by section and then by their Medflyt code.
 * Codes are strings that usually hold digits ("0110"), so they are compared numerically to keep
 * "0090" ahead of "0110" and to avoid "10" sorting before "9".
 */
export function bySectionThenCode<T extends { section: string; code: string }>(
  left: T,
  right: T
): number {
  const bySection = left.section.localeCompare(right.section);

  if (bySection !== 0) {
    return bySection;
  }

  return left.code.localeCompare(right.code, undefined, { numeric: true });
}

/** Shown against rows that do not report to the external system yet. */
export const UNMAPPED_MARKER = "⚠️";
